import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

export default function SlaPerformance({ tickets, isLoading }) {
  // Processar dados para o gráfico SLA
  const getSlaData = () => {
    // Se não houver tickets, calcular SLA baseado em critério padrão
    if (!tickets || tickets.length === 0) {
      return [
        { name: 'Dentro do SLA', value: 0, color: '#10B981' },
        { name: 'Fora do SLA', value: 0, color: '#EF4444' }
      ];
    }
    
    // Calcular SLA real baseado em due_date e created_at
    const now = new Date();
    let withinSla = 0;
    let breachedSla = 0;
    
    tickets.forEach(ticket => {
      const isResolved = ['resolved', 'closed'].includes(ticket.status);
      const createdAt = new Date(ticket.created_at);
      const dueDate = ticket.due_date ? new Date(ticket.due_date) : new Date(createdAt.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 dias padrão
      const resolvedAt = ticket.resolved_at ? new Date(ticket.resolved_at) : now;
      
      if (isResolved) {
        // Ticket resolvido: verificar se foi dentro do prazo
        if (resolvedAt <= dueDate) {
          withinSla++;
        } else {
          breachedSla++;
        }
      } else {
        // Ticket ativo: verificar se já venceu
        if (now <= dueDate) {
          withinSla++;
        } else {
          breachedSla++;
        }
      }
    });
    
    return [
      { name: 'Dentro do SLA', value: withinSla, color: '#10B981' },
      { name: 'Fora do SLA', value: breachedSla, color: '#EF4444' }
         ];
  };
  
  const data = getSlaData();
  const totalTickets = data.reduce((sum, item) => sum + item.value, 0);
  const inSlaPercentage = totalTickets > 0 
    ? Math.round((data[0].value / totalTickets) * 100) 
    : 0;
  
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  return (
    <div>
      <div className="text-center mb-2">
        <span className="text-2xl font-bold">{inSlaPercentage}%</span>
        <p className="text-sm text-muted-foreground">Dentro do SLA</p>
      </div>
      <div className="h-52">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={70}
              fill="#8884d8"
              paddingAngle={5}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip 
              formatter={(value) => [`${value} Chamados`, 'Quantidade']}
            />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}